import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { SessionService } from './shared/_service/session.service';
import { AuthService } from './auth/_service/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from './shared/_service/api.service';
import { environment } from 'src/environments/environment';
import * as Sentry from '@sentry/angular';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
})
export class AppComponent implements OnInit, OnDestroy {
	constructor(
		private router: Router,
		private session: SessionService,
		private auth: AuthService,
		private api: ApiService,
		private translate: TranslateService,
	) {
		translate.setDefaultLang(environment.lang);
		translate.use(environment.lang);
	}

	ngOnInit() {
		if (this.auth.isLoggedIn) {
			// Carico in sessione i prodotti e il carrello
			this.session.getCarrello(true).subscribe();

			this.api.listDizionari({ codice_lingua: environment.lang }).subscribe((res) => {
				const translations = this.translate.translations;
				res.forEach(({ idBertazzoni, valore }) => {
					translations[environment.lang][idBertazzoni] = valore;
				});
				this.translate.setTranslation(environment.lang, translations[environment.lang]);
				console.log('Mappa valori e traduzioni', this.translate.translations);
			});
		}

		this.router.events.subscribe((evt) => {
			if (evt instanceof NavigationEnd) {
				window.scrollTo(0, 0);
			}
		});

		if (environment.production) {
			console.log('Inizializazione Sentry...');
			Sentry.init({
				dsn: environment.sentryDsn,
				integrations: [],
				release: `RELEASE_${environment.buildNumber}`,
			});
		}
	}

	ngOnDestroy() {}
}
